/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateAvailableMerchantCategories200ResponseReissueOneOf
 */
export interface UpdateAvailableMerchantCategories200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseReissueOneOf
     */
    'cardType': UpdateAvailableMerchantCategories200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const UpdateAvailableMerchantCategories200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type UpdateAvailableMerchantCategories200ResponseReissueOneOfCardTypeEnum = typeof UpdateAvailableMerchantCategories200ResponseReissueOneOfCardTypeEnum[keyof typeof UpdateAvailableMerchantCategories200ResponseReissueOneOfCardTypeEnum];


